import { render } from "./create_promotion_form.vue?vue&type=template&id=44b18b35&scoped=true"
import script from "./create_promotion_form.vue?vue&type=script&lang=js"
export * from "./create_promotion_form.vue?vue&type=script&lang=js"

import "./create_promotion_form.vue?vue&type=style&index=0&id=44b18b35&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b18b35"]])

export default __exports__